var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "EmdFormGroup",
    {
      attrs: {
        label: _vm.$t("phone-type"),
        required: "",
        state: _vm.getState(_vm.$v.recipient.phone_numbers.type),
        feedbacks: _vm.feedbacks(_vm.$v.recipient.phone_numbers.type),
      },
    },
    [
      _c(
        "EmdSelect",
        {
          attrs: { name: "phone_type" },
          on: { click: () => _vm.$v.recipient.phone_numbers.type.$touch() },
          model: {
            value: _vm.recipient.phone_numbers[0].type,
            callback: function ($$v) {
              _vm.$set(_vm.recipient.phone_numbers[0], "type", $$v)
            },
            expression: "recipient.phone_numbers[0].type",
          },
        },
        [
          _c("option", { attrs: { value: "fixed" } }, [
            _vm._v(_vm._s(_vm.$t("phone-type-fixed"))),
          ]),
          _c("option", { attrs: { value: "mobile" } }, [
            _vm._v(_vm._s(_vm.$t("phone-type-mobile"))),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }